import React from 'react'
import Result from 'components/Result'

const R3 = () => {
  return (
    <Result
      type="カジュアル系タイプ"
      slides={[
        {
          src: 'img-r3-1.jpg',
          brand: 'Costarellos',
          shop: '神戸元町本店',
          href: 'https://www.ws-i.jp/dress_category/brand/main_brand/40_costarellos/',
        },
      ]}
    />
  )
}

export default R3
